/**
 * Define all of your application routes here
 * for more information on routes, see the
 * official documentation https://router.vuejs.org/en/
 */
export default [
    {
      path: '/',
      name: 'Landing',
      view: 'Landing',
      meta: {
        requiresAuth: false
      }
    },
    {
      path: '/catalog',
      name: 'Catalog',
      view: 'Catalog',
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/order',
      name: 'Order',
      view: 'Order',
      meta: {
        requiresAuth: true
      }
    },
    // {
    //     path: '/dashboard',
    //     name: 'Dashboard',
    //     view: 'Dashboard',
    //     meta: {
    //     requiresAuth: true,
    //     minimumLevel: 2,
    //     userOnly: true,
    //     vendorOnly: false
    //     }
    // },
    // {
    //     path: '/account',
    //     name: 'Account',
    //     view: 'Account',
    //     meta: {
    //     requiresAuth: true,
    //     minimumLevel: 0,
    //     userOnly: true,
    //     vendorOnly: false
    //     }
    // },
    // {
    //     path: '/bank',
    //     name: 'Bank',
    //     view: 'Plaid',
    //     meta: {
    //     requiresAuth: true,
    //     minimumLevel: 1,
    //     userOnly: true,
    //     vendorOnly: false
    //     }
    // },
    // {
    //     path: '/plan',
    //     name: 'Plan',
    //     view: 'Plan',
    //     meta: {
    //     requiresAuth: false,
    //     minimumLevel: 0,
    //     userOnly: true,
    //     vendorOnly: false
    //     }
    // },
    // {
    //     path: '/reward',
    //     name: 'Reward',
    //     view: 'Reward',
    //     meta: {
    //     requiresAuth: false,
    //     minimumLevel: 0,
    //     userOnly: true,
    //     vendorOnly: false
    //     }
    // },
    // {
    //     path: '/terms',
    //     name: 'Terms',
    //     view: 'TOS',
    //     meta: {
    //     requiresAuth: false,
    //     minimumLevel: 0,
    //     userOnly: true,
    //     vendorOnly: true
    //     }
    // },
    // {
    //     path: '/prototype',
    //     name: 'Prototype',
    //     view: 'Prototype',
    //     meta: {
    //     requiresAuth: true,
    //     minimumLevel: -1,
    //     userOnly: false,
    //     vendorOnly: true
    //     }
    // },
    // {
    //     path: '/invite/:id', 
    //     props: true,
    //     view: 'Reward',
    //     name: 'Invite',
    //     meta: {
    //     requiresAuth: false,
    //     minimumLevel: 0,
    //     userOnly: true,
    //     vendorOnly: false}
    // },
    // {
    //     path: '/vendor', 
    //     props: true,
    //     view: 'Retail',
    //     name: 'Retail',
    //     meta: {
    //     requiresAuth: true,
    //     minimumLevel: -1,
    //     userOnly: false,
    //     vendorOnly: true
    //     }
    // },
    // {
    //     path: '/admin', 
    //     props: true,
    //     view: 'Admin',
    //     name: 'Admin',
    //     meta: {
    //     requiresAuth: true,
    //     minimumLevel: -2,
    //     userOnly: false,
    //     vendorOnly: true
    //     }
    // }
]
